import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { EditProfileTitle, Users } from "../../../../Constants/Constants";
import AddProjectsAndUpload from "./AddProjectsAndUpload/AddProjectsAndUpload";
import EditProfileForm from "./EditProfiles/EditProfileForm";
import MyProfile from "./MyProfile/MyProfile";

const EditProfileContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={EditProfileTitle} parent={Users} />
      <Container fluid>
        <div className="edit-profile">
          <Row>
            <MyProfile />
            <EditProfileForm />
            <AddProjectsAndUpload />
          </Row>
        </div>
      </Container>
    </>
  );
};

export default EditProfileContainer;
